<template lang="html">
  <v-data-table
    :headers="headers"
    :items="tableData"
    hide-actions>
    <template
      #headerCell=" { header } ">
      <span
        :class="`font-weight-light text-${color} text--darken-3`"
        v-text="header.text"/>
    </template>
    <template
      #items=" { index, item } ">
      <td
        v-for="(value, propertyName) in item"
        v-if="propertyName !== 'id' && propertyName !== 'info'"
        :key="propertyName"
        class="text-xs-left">
        {{ value }}
      </td>
      <info-cell
        :bookingRequest="item.info.bookingRequest"
        :booked="item.info.booked"
        :dateApproaching="item.info.dateApproaching"/>
      <action-cell :quoteId="item.id" />
    </template>
  </v-data-table>
</template>

<script>
import QuoteTableActionCell from './QuoteTableActionCell'
import QuoteTableInfoCell from './QuoteTableInfoCell'

export default {
  components: {
    'action-cell': QuoteTableActionCell,
    'info-cell': QuoteTableInfoCell
  },
  props: {
    color: {
      type: String,
      required: false,
      default: 'primary'
    },
    quotes: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data: () => ({
    headers: [
      { sortable: false, text: 'Trip ID', value: 'tripID' },
      { sortable: false, text: 'Name', value: 'name' },
      { sortable: false, text: 'Email', value: 'email' },
      { sortable: false, text: 'Details', value: 'details' },
      { sortable: false, text: 'Price', value: 'cost' },
      { sortable: false, text: 'Info', value: 'info' },
      { sortable: false, text: 'Actions', value: 'actions', align: 'right' }
    ],
  }),
  computed: {
    tableData () {
      return this.quotes.map(q => ({
        tripID: q.trip.trip_id,
        name: q.trip.trip_planner.name,
        email: q.trip.trip_planner.email,
        details: `${q.trip.passengers} passengers | ${q.live_miles} mi.`,
        price: q.cost,
        info: {
          bookingRequest: q.request_to_book,
          booked: q.trip.booked,
          dateApproaching: false
        },
        id: q.id
      })).reverse()
    }
  }
}
</script>

<style lang="css" scoped>
</style>
